import cx from 'clsx';
import type { ReactElement } from 'react';
import animationData from '../../assets/lotties/spinner.json' with { type: 'json' };
import type { LottiePlayerProps } from '../lottie-player';
import { LottiePlayer } from '../lottie-player';
import styles from './spinner.module.css';

interface SpinnerProps extends Omit<LottiePlayerProps, 'animationData' | 'size'> {
  /** @deprecated please leverage CSS color property instead */
  color?: 'primary-a' | 'primary-b' | 'primary-b-static' | 'danger';
  size?: 'small' | 'medium' | 'large';
}

export function Spinner({
  size = 'medium',
  color,
  className,
  ...props
}: SpinnerProps): ReactElement {
  return (
    <LottiePlayer
      animationData={animationData}
      className={cx(
        className,
        styles.spinner,
        color ? styles[color] : styles.defaultCurrentColor,
        styles[size]
      )}
      data-test-spinner=""
      {...props}
    />
  );
}
